<template lang="pug">
  div.vkb_nak.vkb_nak_vkb.vkb_nak_risiko_check
    .large-12.columns.pb-3(ref="heading" name="heading")
      .input-wrapper.mt-5(data-abide)
        .highlight.input-wrapper: .row
          .small-12.columns
            label Postleitzahl*
            slv-input-text(v-model="form.plz" id="risiko-plz" :disabled="isPlzValid" :error="getErrorMessage('plz')")

          .small-12.columns(v-if="isPlzValid")
            label Ort*
            slv-select(v-model="form.ort" :items="orte" :disabled="loading" show-empty-item @input="onSearchAddress('ort')")

          .small-12.columns(v-if="strassen")
            label Straße*
            slv-select(v-model="form.strasse" :items="strassen" :disabled="loading" show-empty-item @input="onSearchAddress('strasse')")

          .small-12.columns(v-if="hausnummern")
            label Hausnummer*
            slv-select(v-model="form.hausnummer" :items="hausnummern" :disabled="loading" show-empty-item)

          .small-12.medium-12.large-12.columns.text-right
            span *Pflichtfeld

        .row.d-flex.mt-3
          .btn-wrapper.d-flex.column
            vkb-btn.btn-search.block(v-if="search_started" @click="onNewSearch") neue Suche

          .btn-wrapper.d-flex.column
            vkb-btn.block(
              v-if="!isPlzValid"
              is-cta
              :disabled="loading"
              @click="onSearchAddress('plz')"
            )
              span Ort suchen

            vkb-btn.block(
              v-if="isPlzValid & !gk"
              is-cta
              :disabled="!isFormValid || loading_gk"
              @click="onCalculate"
            )
              span Risiko ermitteln

      a(ref="calc-result")
      #calc-result.accordion-wrapper.text-left.mt-8(v-if="gk")
        h3 Ergebnis Risikocheck
        h4 Individuelle Eintrittswahrscheinlichkeit für Ihren Wohnort und durchschnittliches finanzielles Risiko</h3>

        dl.accordion.mt-3
          template(v-for="accordion in riskAccordions")
            dt: a(
              :class="open_accordion === accordion.id && 'active'"
              :key="`dt-${ accordion.id }`"
              @click="onOpenAccordion(accordion.id)"
            )
              .row.d-flex.align-center
                .column.small-12.medium-6.d-flex.align-center
                  img.risk-icon(:src="icon_images[accordion.icon_name]")
                  span {{ accordion.title }}

                .column.small-12.medium-6.risk-progress
                  progress-indicator.slv.mr-2(:value="accordion.progress1")
                  progress-indicator.slv.mr-5(:value="accordion.progress2" type="euro")

            dd: .content(:class="open_accordion === accordion.id && 'active'")
              ul.square
                li(v-for="d, i in accordion.descriptions" :key="i" v-html="d")
              p
                b.mr-1 Tipp:<br>
                span(v-html="accordion.tip")

              template(v-if="accordion.id === 2")
                ul.square.mt-4
                  li(v-for="d, i in accordion.hagel_descriptions" :key="i" v-html="d")
                p
                  b.mr-1 Tipp:<br>
                  span(v-html="accordion.hagel_tip")

        .row.clearfix
          .small-12.medium-12.large-12.column.d-flex.justify-end
            .d-flex.justify-end
              .d-flex.align-center
                span.mr-1 nie
                progress-indicator.slv.mr-2(:value="0" size="sm")

              .d-flex.align-center
                span.mr-1 häufig
                progress-indicator.slv.mr-2(:value="5" size="sm")

            .d-flex.justify-end
              .d-flex.align-center
                span.mr-1 geringe Schadenssumme
                progress-indicator.slv.mr-2(:value="1" type="euro" size="sm")

              .d-flex.align-center
                span.mr-1 Totalschaden
                progress-indicator.slv.mr-2(:value="5" type="euro" size="sm")

        .row.mt-6
          .d-flex.small-12.medium-6.large-3.large-offset-5.column.text-left
            vkb-btn.block.mb-2(:disabled="loading_pdf" @click="onDownloadPdf")
              i.fo.fo-download
              span Angebot speichern

          .d-flex.small-12.medium-6.large-4.column
            vkb-btn.block.mb-2(is-cta @click="onContactClick")
              span Zur Beratung

</template>

<script>
import SlvInputText from '@/components/common/slv-input-text';
import SlvSelect from '@/components/common/slv-select';
import logic from './logic.js';

export default {
  name: 'risiko_check',

  components: {
    SlvInputText,
    SlvSelect
  },

  mixins: [
    logic
  ],

  data: () => ({
    icon_images: {
      starkregen: require('@/assets/images/slv_starkregen.png'),
      sturm: require('@/assets/images/slv_sturm.png'),
      feuer: require('@/assets/images/slv_feuer.png'),
      blitzschlag: require('@/assets/images/slv_blitzschlag.png'),
      leitungswasser: require('@/assets/images/slv_leitungswasser.png'),
    }
  }),

  created() {
    window.addEventListener('scroll', this.onScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/risiko_check/slv.vue